<template>
  <div>
    <template v-if="shop==null">
      <div style="height:200px;"></div>
      <h3 class="mt-5 text-xs-center">กำลังโหลด</h3>
    </template>
    <v-container fluid class="pt-3" v-if="shop!=null">
      <vue-headful :title="`ข้อมูลร้านค้า - Halalize for Business`" />

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/shops' }">ร้านค้า</el-breadcrumb-item>
        <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
      </el-breadcrumb>

      <section class="mt-4">
        <el-tabs :tab-position="`top`">
          <el-tab-pane label="ข้อมูลทั่วไป">
            <v-layout row wrap class="mx-1">
              <v-flex xs12 md8>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">รายละเอียดร้านค้า</span>
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      v-if="!editDetail"
                      @click="editDetail=true"
                    >แก้ไข</el-button>
                  </div>
                  <v-layout>
                    <v-flex xs3>
                      <img :src="shop.logo_url" style="width:75%;" />
                    </v-flex>
                    <v-flex xs9 class="px-2">
                      <template v-if="!editDetail">
                        <h4 class="subheader">
                          <el-tag
                            v-if="shop.status=='published'"
                            size="mini"
                            type="success"
                          >{{shop.status}}</el-tag>
                          <el-tag v-else size="mini" type="warning">{{shop.status}}</el-tag>
                          {{shop.name}}
                        </h4>
                        <div class="grey--text darken-3 font-sm mt-1">{{shop.formatted_address}}</div>
                        <div
                          class="grey--text darken-3 font-sm"
                        >({{shop.latitude}},{{shop.longitude}})</div>
                      </template>
                      <template v-else>
                        <el-form :label-position="`top`" label-width="100px" size="mini">
                          <el-form-item label="สถานะ">
                            <el-select v-model="shop.status" placeholder="Select">
                              <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ชื่อร้าน">
                            <el-input v-model="shop.name"></el-input>
                          </el-form-item>
                          <el-form-item label="คำอธิบาย">
                            <el-input v-model="shop.excerpt"></el-input>
                          </el-form-item>
                          <el-form-item label="ที่อยู่">
                            <el-input readonly v-model="shop.formatted_address">
                              <el-button
                                slot="append"
                                icon="far fa-map"
                                @click="addressDialog=true"
                              ></el-button>
                            </el-input>
                          </el-form-item>
                          <el-form-item label="พิกัด">
                            <el-col :span="9">
                              <el-form-item>
                                <el-input v-model="shop.latitude"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col class="line" :span="1">&nbsp;</el-col>
                            <el-col :span="9">
                              <el-form-item>
                                <el-input v-model="shop.longitude"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-form-item>
                          <el-form-item size="mini">
                            <el-button type="danger" @click="onShopDetailSubmit">บันทึก</el-button>
                          </el-form-item>
                        </el-form>
                      </template>
                    </v-flex>
                  </v-layout>
                </el-card>
                <el-card class="box-card mt-3">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">ข้อมูลติดต่อ</span>
                    <!--
                  <el-button style="float: right; padding: 3px 0" type="text">Edit</el-button>
                    -->
                  </div>
                  <v-layout>
                    <v-flex xs12>
                      <div class="mb-2" v-bind:key="index" v-for="(item, index) in shop.contacts">
                        <el-input
                          placeholder="Please input value"
                          v-model="item.value"
                          class="input-with-select"
                          size="mini"
                          :disabled="true"
                        >
                          <el-select
                            v-model="item.type"
                            slot="prepend"
                            placeholder="Select"
                            style="width:100px;"
                            disabled
                          >
                            <el-option label="เบอร์มือถือ" value="mobile"></el-option>
                            <el-option label="อีเมล" value="email"></el-option>
                            <el-option label="เวปไซต์" value="website"></el-option>
                            <el-option label="เพจ Facebook" value="fbpage"></el-option>
                            <el-option label="Instagram" value="instagram"></el-option>
                            <el-option label="Line" value="line"></el-option>
                          </el-select>
                          <el-button
                            slot="append"
                            icon="far fa-trash-alt"
                            type="danger"
                            @click="onContactDeleted(index)"
                          ></el-button>
                        </el-input>
                      </div>
                      <div class="mb-2">
                        <el-input
                          placeholder="Please input"
                          v-model="contact.value"
                          class="input-with-select"
                          size="mini"
                        >
                          <el-select
                            v-model="contact.type"
                            slot="prepend"
                            placeholder="Select"
                            style="width:100px;"
                          >
                            <el-option label="เบอร์มือถือ" value="mobile"></el-option>
                            <el-option label="อีเมล" value="email"></el-option>
                            <el-option label="เวปไซต์" value="website"></el-option>
                            <el-option label="เพจ Facebook" value="fbpage"></el-option>
                            <el-option label="Instagram" value="instagram"></el-option>
                            <el-option label="Line" value="line"></el-option>
                          </el-select>
                          <el-button slot="append" icon="fas fa-plus" @click="onContactAdded"></el-button>
                        </el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                </el-card>
                <el-card class="box-card mt-3">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">เวลาให้บริการ</span>
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      v-if="!editHour"
                      @click="editHour=true"
                    >แก้ไข</el-button>

                    <template v-else>
                      <el-button
                        style="float: right;"
                        class="ml-2"
                        size="mini"
                        @click="onUpdateHourCancelled()"
                      >ยกเลิก</el-button>
                      <el-button
                        style="float: right;"
                        type="primary"
                        class="ml-2"
                        size="mini"
                        @click="onUpdateHour()"
                      >บันทึก</el-button>
                    </template>
                  </div>
                  <v-layout>
                    <v-flex>
                      <el-form
                        v-if="deliveryHours"
                        :label-position="`left`"
                        label-width="100px"
                        size="mini"
                      >
                        <div
                          class="mb-2"
                          v-bind:key="index"
                          v-for="(item, index) in deliveryHours.items"
                        >
                          <el-form-item :label="dayList[item.day-1]">
                            <el-col :span="5">
                              <el-time-select
                                :disabled="!editHour"
                                style="width:100px;"
                                v-model="deliveryHours.items[index].start_hour"
                                :picker-options="timeOption"
                                placeholder="Select time"
                              ></el-time-select>
                            </el-col>
                            <el-col :span="2" class="px-2 text-xs-center">ถึง</el-col>
                            <el-col :span="5">
                              <el-time-select
                                :disabled="!editHour"
                                style="width:100px;"
                                v-model="deliveryHours.items[index].end_hour"
                                :picker-options="timeOption"
                                placeholder="Select time"
                              ></el-time-select>
                            </el-col>
                            <template v-if="editHour">
                              <el-col :span="4" class="px-2">
                                <el-checkbox
                                  v-model="deliveryHours.items[index].always_open"
                                >เปิดทั้งวัน</el-checkbox>
                              </el-col>
                              <el-col :span="4" class="px-2">
                                <el-checkbox
                                  v-model="deliveryHours.items[index].always_close"
                                >ปิดทั้งวัน</el-checkbox>
                              </el-col>
                            </template>
                            <template v-else>
                              <el-col :span="8" class="px-2">
                                <el-tag
                                  size="mini"
                                  type="danger"
                                  v-if="deliveryHours.items[index].always_close"
                                >ปิดทั้งวัน</el-tag>
                                <span
                                  size="mini"
                                  type="success"
                                  v-if="deliveryHours.items[index].always_open"
                                >เปิดทั้งวัน</span>
                              </el-col>
                            </template>
                          </el-form-item>
                        </div>
                      </el-form>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </el-card>
                <div style="height:60px;"></div>
              </v-flex>
              <v-flex xs12 md4 class="pl-2">
                <el-card class="box-card">
                  <picture-input
                    ref="pictureInput"
                    width="150"
                    height="150"
                    margin="0"
                    accept="image/jpeg, image/png"
                    size="10"
                    button-class="btn"
                    :custom-strings="{
                            upload: '<h1>Upload Logo!</h1>',
                            drag: 'Upload Logo Here'
                          }"
                    @change="onImageLogoChanged"
                  ></picture-input>
                </el-card>

                <el-card class="box-card mt-3">
                  <picture-input
                    ref="pictureInput"
                    width="150"
                    height="150"
                    margin="0"
                    accept="image/jpeg, image/png"
                    size="10"
                    button-class="btn"
                    :custom-strings="{
                            upload: '<h1>Upload Cover!</h1>',
                            drag: 'Upload Cover Here'
                          }"
                    @change="onImageCoverChanged"
                  ></picture-input>
                </el-card>
              </v-flex>
            </v-layout>
          </el-tab-pane>
          <el-tab-pane label="จัดการหน้าร้าน">
            <v-layout row wrap class="mx-1">
              <v-flex xs12 md8>
                <el-card class="box-card"></el-card>
              </v-flex>
              <v-flex xs12 md4 class="pl-2">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">หมวดหมู่สินค้า</span>
                    <!--
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      @click="categoryDialog=true"
                    >เพิ่มใหม่</el-button>
                    -->
                  </div>
                  <v-list>
                    <v-list-tile style="border:1px solid #eee;" class="mb-2">
                      <v-list-tile-content>โปรโมชั่น</v-list-tile-content>
                    </v-list-tile>
                    <draggable
                      v-model="categoryDraggableList"
                      group="category"
                      @start="drag=true"
                      @end="onCategoryDragEnded()"
                    >
                      <template v-for="(item, index) in categoryDraggableList">
                        <v-list-tile :key="index" style="border:1px solid #eee;" class="mb-2">
                          <i class="fas fa-bars drag-pointer"></i>
                          <v-list-tile-content>{{item.label}}</v-list-tile-content>
                          <v-list-tile-action v-if="item.value!=0" style="display: -webkit-box;">
                            <v-btn
                              @click="openEditCategoryDialog(item)"
                              icon
                              ripple
                              color="grey--text"
                              class="mr-1"
                            >
                              <i class="far fa-edit"></i>
                            </v-btn>
                            <v-menu bottom left>
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon ripple color="grey--text">
                                  <i class="fas fa-times"></i>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-tile @click="onRemoveCategory(item)">
                                  <v-list-tile-title>ลบหมวดหมู่นี้</v-list-tile-title>
                                </v-list-tile>
                              </v-list>
                            </v-menu>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>
                    </draggable>
                    <v-list-tile style="border:1px solid #eee;" class="mb-2">
                      <v-list-tile-content>อื่นๆ</v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </el-card>

                <v-dialog v-model="editCategoryDialog" persistent max-width="600px">
                  <v-card v-if="selectedCategory!=null">
                    <v-card-title>
                      <span class="headline">แก้ไขหมวดหมู่</span>
                    </v-card-title>
                    <v-card-text>
                      <el-form label-position="left" label-width="100px" @submit.native.prevent>
                        <el-form-item label="ชื่อหมวดหมู่">
                          <el-col :span="11">
                            <el-input v-model="selectedCategory.label"></el-input>
                          </el-col>
                        </el-form-item>
                      </el-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="darken-2" flat @click="editCategoryDialog=false">ปิด</v-btn>
                      <v-btn color="primary" depressed @click="onEditCategory">บันทึก</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
          </el-tab-pane>
          <el-tab-pane label="รายการสินค้า">
            <v-layout>
              <v-flex xs12>
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">สินค้าทั้งหมด</span>
                    <el-button
                      style="float: right;"
                      size="small"
                      type="info"
                      @click="productUploadDrawer=true"
                    >อัพโหลด</el-button>

                    <el-button
                      style="float: right;"
                      class="mr-2"
                      size="small"
                      type="danger"
                      @click="productDrawer=true"
                    >เพิ่มสินค้าใหม่</el-button>
                  </div>
                  <div>
                    <el-table :data="productList" style="width:100%; height:100%;">
                      <el-table-column prop="product_id" label="ID" width="60"></el-table-column>
                      <el-table-column label="สถานะ" width="120">
                        <template slot-scope="props">
                          <el-select
                            v-model="props.row.status"
                            placeholder="Select"
                            :size="`mini`"
                            @change="onUpdateStatus(props.row)"
                          >
                            <el-option
                              v-for="item in productStatusList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="product_type" label="ประเภท" width="150">
                        <template slot-scope="props">
                          <span v-if="props.row.product_type=='a_la_carte'">อาหารจานเดียว</span>
                          <span v-if="props.row.product_type=='customise'">อาหารที่มีตัวเลือก</span>
                          <span v-if="props.row.product_type=='product'">สินค้าอีคอมเมิร์ซ</span>
                          <span v-if="props.row.product_type=='coupon'">คูปอง/บัตรกำนัล</span>
                          <span v-if="props.row.product_type=='free_item'">ของแถม</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="name" label="ชื่อสินค้า" width="350">
                        <template slot-scope="props">
                          <div
                            class="pic"
                            :style="{ backgroundImage: 'url(' + props.row.image + ')' }"
                          ></div>
                          <div style="padding-left:60px;">
                            <div class="font-weight-bold">{{props.row.name}}</div>
                            <div class="grey--text">{{props.row.excerpt}}</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="หมวดหมู่" width="250">
                        <template slot-scope="props">
                          <el-select
                            v-model="props.row.groups[0].id"
                            placeholder="Select"
                            :size="`mini`"
                            @change="onUpdateCategory(props.row)"
                          >
                            <el-option
                              v-for="item in categoryList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="regular_price" label="ราคา"></el-table-column>
                      <!--
                    <el-table-column prop="cog" label="ต้นทุน"></el-table-column>
                      -->
                      <el-table-column label align="right">
                        <template slot-scope="props">
                          <el-button
                            type="text"
                            size="small"
                            @click="openProduct(props.row)"
                          >รายละเอียด</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-card>
              </v-flex>
            </v-layout>
          </el-tab-pane>
          <el-tab-pane label="คำสั่งซื้อ">
            <OrderTable :shop="shop" :showStat="true"></OrderTable>
          </el-tab-pane>
          <!--
        <el-tab-pane label="การชำระเงิน">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <el-card class="box-card mt-3">
                <el-form ref="form" :model="invoiceForm" label-width="120px">
                  <el-form-item label="Date">
                    <el-date-picker
                      size="small"
                      v-model="invoiceForm.daterange"
                      type="daterange"
                      range-separator="To"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="Customer Name">
                    <el-input v-model="invoiceForm.name" size="small"></el-input>
                  </el-form-item>
                  <el-form-item label="Address">
                    <el-input type="textarea" v-model="invoiceForm.address" size="small"></el-input>
                  </el-form-item>
                  <el-form-item label="Tax ID">
                    <el-input v-model="invoiceForm.tax_id" size="small"></el-input>
                  </el-form-item>
                  <el-form-item label="Branch Code">
                    <el-input v-model="invoiceForm.branch" size="small"></el-input>
                  </el-form-item>
                  <el-form-item label="Remark">
                    <el-input type="textarea" v-model="invoiceForm.remark" size="small"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      type="primary"
                      class="ml-2"
                      size="mini"
                      @click="onCreateInvoice"
                    >Create Invoice</el-button>
                  </el-form-item>
                </el-form>
              </el-card>
            </v-flex>
          </v-layout>
        </el-tab-pane>
          -->
          <!-- <el-tab-pane label="Team">Team</el-tab-pane> -->
          <!--
          <el-tab-pane label="พื้นที่บริการ">
            <v-layout row wrap>
              <v-flex xs12 md8>
                <section>
                  <gmap-map
                    :center="mapCenter"
                    :zoom="12"
                    :options="mapConfig"
                    ref="gmap"
                    map-type-id="roadmap"
                    style="height: 550px"
                    class="map-container"
                  >
                    <GmapMarker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :clickable="false"
                      :draggable="false"
                    />
                  </gmap-map>
                </section>
              </v-flex>
              <v-flex xs12 md4 class="pl-2"></v-flex>
            </v-layout>
          </el-tab-pane>
          -->
          <el-tab-pane label="การตั้งค่า">
            <v-layout row wrap class="mx-1">
              <v-flex xs12 md8>
                <el-card class="box-card mt-3">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">ประเภทการสั่ง</span>
                  </div>
                  <v-layout row wrap class="px-3">
                    <v-flex>
                      <el-checkbox-group v-model="selectedOrderType" @change="onOrderTypeChanged()">
                        <el-checkbox label="delivery">เดลิเวอรี่</el-checkbox>
                        <el-checkbox label="pickup">รับอาหารที่ร้าน</el-checkbox>
                      </el-checkbox-group>
                    </v-flex>
                  </v-layout>
                </el-card>

                <el-card class="box-card mt-3">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">ประเภทการจัดส่ง</span>
                  </div>
                  <v-layout row wrap class="px-3">
                    <v-flex>
                      <el-checkbox-group
                        v-model="selectedDeliveryType"
                        @change="onDeliveryTypeChanged()"
                      >
                        <el-checkbox label="asap">ส่งด่วน</el-checkbox>
                        <el-checkbox label="cluster">ส่งตามรอบ</el-checkbox>
                      </el-checkbox-group>
                    </v-flex>
                  </v-layout>
                </el-card>

                <!-- START SETTING CLUSTER -->
                <el-card class="box-card mt-3" v-if="selectedDeliveryType.includes('cluster')">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">รอบส่ง</span>
                    <el-button
                      style="float: right; padding: 3px 0"
                      type="text"
                      @click="newClusterDialog=true"
                    >เพิ่มใหม่</el-button>
                  </div>
                  <el-table :data="clusterJson" style="width: 100%">
                    <el-table-column prop="id" label="#" width="80"></el-table-column>
                    <el-table-column label="เวลารับออเดอร์" width="180">
                      <template
                        slot-scope="props"
                      >{{props.row.order_start_time}} - {{props.row.order_end_time}}</template>
                    </el-table-column>
                    <el-table-column prop="delivery" label="เวลาจัดส่ง" width="180"></el-table-column>
                    <el-table-column prop="advanced" label="ล่วงหน้า (วัน)" width="100"></el-table-column>
                    <el-table-column label>
                      <template slot-scope="props">
                        <div class="text-xs-right">
                          <el-button
                            slot="append"
                            icon="far fa-trash-alt"
                            size="mini"
                            type="danger"
                            @click="onRemoveCluster(props.row)"
                          ></el-button>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <v-dialog
                    v-model="newClusterDialog"
                    persistent
                    transition="dialog-bottom-transition"
                    width="450px"
                  >
                    <v-card>
                      <v-card-title>
                        <strong>เพิ่มรอบส่งใหม่</strong>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="height: 380px;" class="text-xs-center">
                        <el-form
                          :label-position="`top`"
                          size="medium"
                          label-width="130px"
                          class="mt-3"
                        >
                          <el-form-item label="ช่วงเวลารับออเดอร์">
                            <el-col :span="24">
                              <el-time-select
                                is-range
                                v-model="clusterForm.order_startTime"
                                style="width:120px;"
                                class="mr-3"
                                :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '23:45',
                                maxTime: clusterForm.order_endTime
                              }"
                              ></el-time-select>ถึง
                              <el-time-select
                                is-range
                                v-model="clusterForm.order_endTime"
                                style="width:120px;"
                                class="ml-3"
                                :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '23:45',
                                minTime: clusterForm.order_startTime,
                              }"
                              ></el-time-select>
                            </el-col>
                          </el-form-item>
                          <el-form-item label="เวลาจัดส่ง">
                            <el-col :span="24">
                              <el-time-select
                                is-range
                                v-model="clusterForm.delivery_startTime"
                                style="width:120px;"
                                class="mr-3"
                                :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '23:45',
                                minTime: clusterForm.order_endTime,
                                maxTime: clusterForm.delivery_endTime
                              }"
                              ></el-time-select>ถึง
                              <el-time-select
                                is-range
                                v-model="clusterForm.delivery_endTime"
                                style="width:120px;"
                                class="ml-3"
                                :picker-options="{
                                start: '00:00',
                                step: '00:15',
                                end: '23:45',
                                minTime: clusterForm.delivery_startTime
                              }"
                              ></el-time-select>
                            </el-col>
                          </el-form-item>
                          <el-form-item label="ล่วงหน้า">
                            <el-col :span="24">
                              <el-select v-model="clusterForm.advanced" placeholder="เลือกจำนวนวัน">
                                <el-option
                                  v-for="item in [0,1,2,3]"
                                  :key="item"
                                  :label="item"
                                  :value="item"
                                ></el-option>
                              </el-select>
                            </el-col>
                          </el-form-item>
                        </el-form>
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" flat @click="newClusterDialog = false">ปิด</v-btn>
                        <v-btn color="red darken-2" flat @click="onClusterSave">บันทึก</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </el-card>
                <!-- END SETTING CLUSTER -->

                <el-card class="box-card mt-3">
                  <div slot="header" class="clearfix">
                    <span class="font-weight-bold">LINE Group ID</span>
                    <!--
                  <el-button style="float: right; padding: 3px 0" type="text">Edit</el-button>
                    -->
                  </div>
                  <v-layout>
                    <v-flex xs12>
                      <el-input
                        placeholder="Please input line group ID"
                        size="mini"
                        v-model="shop.linegroup_id"
                      >
                        <el-button slot="append" @click="onLineGroupSaved">บันทึก</el-button>
                      </el-input>
                    </v-flex>
                  </v-layout>
                </el-card>
              </v-flex>
            </v-layout>
          </el-tab-pane>
        </el-tabs>
      </section>
      <address-dialog
        :showDialog="addressDialog"
        @save="onSaveAddress"
        @close="addressDialog=false"
      ></address-dialog>
      <create-product-drawer
        :dialog="productDrawer"
        :shopId="shop.shop_id"
        @close="productDrawer=false"
        @save="onProductCreated"
      ></create-product-drawer>

      <v-dialog persistent v-model="productUploadDrawer" scrollable max-width="600px">
        <v-card>
          <v-card-title>
            <strong>อัพโหลดสินค้า</strong>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="text-xs-center">
              <el-upload
                class="upload-demo"
                drag
                :on-success="handleImportSuccess"
                :on-progress="handleImportProgress"
                :file-list="file"
                :multiple="false"
                :action="deliveryApiDomain+`/console/products/import`"
                :headers="uploadHeaders"
                :data="importData"
                :auto-upload="true"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">อัพโหลดสินค้า</div>
                <div class="el-upload__tip" slot="tip">
                  ดาวน์โหลดไฟล์ Excel สำหรับสินค้า
                  <a
                    href="https://drive.google.com/file/d/1yfsXvqkiCqi1L5fQg00M35HCCCy9OM9F/view?usp=sharing"
                    target="_blank"
                  >คลิกที่นี่</a>
                </div>
              </el-upload>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <el-button size="small" @click="productUploadDrawer=false">ยกเลิก</el-button>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Service from "../../services";

import moment from "moment";
import {
  dayList,
  deliveryHourList,
  deliveryApiDomain,
  harisChannelKey
} from "../../utils/Constants";
import AddressDialog from "../../components/AddressDialog";
import CreateProductDrawer from "../../components/CreateProductDrawer";
import OrderTable from "../../components/table/OrderTable";
import PictureInput from "vue-picture-input";
import draggable from "vuedraggable";
export default {
  components: {
    PictureInput,
    AddressDialog,
    CreateProductDrawer,
    OrderTable,
    draggable
  },
  props: ["ref_no"],
  data() {
    return {
      deliveryApiDomain: deliveryApiDomain,
      productDrawer: false,
      productUploadDrawer: false,
      newClusterDialog: false,
      editCategoryDialog: false,

      selectedCategory: null,
      loading: null,
      isLoading: true,
      shop: null,
      contact: { type: "mobile", value: "" },
      statusList: [
        { label: "Draft", value: "draft" },
        { label: "Inactive", value: "inactive" },
        { label: "Published", value: "published" }
      ],
      productStatusList: [
        { label: "ยังไม่เรียบร้อย", value: "draft" },
        { label: "ไม่พร้อมขาย", value: "inactive" },
        { label: "ขายหมด", value: "soldout" },
        { label: "ใช้งานอยู่", value: "published" }
      ],
      timeOption: {
        start: "06:00",
        step: "00:15",
        end: "23:45"
      },
      invoiceForm: {
        daterange: "",
        name: "",
        address: "",
        tax_id: "",
        branch: "",
        remark: ""
      },
      categoryList: [],
      categoryDraggableList: [],
      title: "",
      editDetail: false,
      editHour: false,
      addressDialog: false,
      image: null,
      hasImage: false,
      productList: [],
      deliveryHours: [],
      dayList: dayList,
      startHourList: [],
      endHourList: [],
      mapCenter: {
        lat: 13.736717,
        lng: 100.523186
      },
      mapConfig: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true
      },
      markers: [],
      polygonList: [],
      file: [],
      importData: {},
      uploadHeaders: {
        Authorization: ""
      },
      selectedDeliveryType: ["cluster"],
      selectedOrderType: [],
      clusterJson: [],
      clusterForm: {
        order_startTime: "09:00",
        order_endTime: "12:00",
        delivery_startTime: "12:30",
        delivery_endTime: "13:30",
        order_range: [new Date(2020, 5, 1, 9, 0), new Date(2020, 5, 1, 11, 0)],
        delivery_range: [
          new Date(2020, 5, 1, 12, 0),
          new Date(2020, 5, 1, 13, 30)
        ],
        advanced: 0
      }
    };
  },
  created() {
    let vuex = JSON.parse(localStorage.getItem("halalize"));
    let accessToken = vuex.Auth.accessToken;
    this.uploadHeaders.Authorization = "Bearer " + accessToken;
    this.importData = { ref_no: this.ref_no };
    Service.Shop.get(this.ref_no).then(res => {
      if (res.success) {
        this.shop = res.data;
        this.title = this.shop.name;
        if (this.shop.cluster_json != null) {
          this.clusterJson = this.shop.cluster_json;
        }
        if (this.shop.delivery_type != null) {
          this.selectedDeliveryType = this.shop.delivery_type;
        }

        this.mapCenter = {
          lat: parseFloat(this.shop.latitude),
          lng: parseFloat(this.shop.longitude)
        };

        this.markers.push({
          position: { ...this.mapCenter }
        });

        this.renderHours();
        this.loadProduct();
        this.loadCategories();

        this.startHourList = deliveryHourList.map(item => {
          return { value: item, label: item };
        });
        this.endHourList = deliveryHourList.map(item => {
          return { value: item, label: item };
        });

        if (this.shop.allow_delivery) {
          this.selectedOrderType.push("delivery");
        }
        if (this.shop.allow_pickup) {
          this.selectedOrderType.push("pickup");
        }
      }
    });
  },
  methods: {
    openOrder(item) {
      this.$router.push("/view/order/" + item.order_id);
    },
    loadProduct() {
      Service.Delivery.getProductByShop(this.shop.shop_id).then(res => {
        this.productList = res.data;
      });
    },
    loadCategories() {
      Service.Shop.getCategories(this.shop.shop_id).then(res => {
        if (res.success) {
          this.categoryList = res.data.map(item => {
            let r = {
              label: item.name,
              value: item.product_cate_id,
              rank: item.rank
            };
            this.categoryDraggableList.push(r);
            return r;
          });
          this.categoryList.push({ label: "อื่นๆ", value: 0, rank: 9999 });

          this.categoryDraggableList = this.categoryDraggableList.sort((a, b) =>
            a.rank > b.rank ? 1 : b.rank > a.rank ? -1 : 0
          );
        }
      });
    },
    loadOrders() {
      let params = {
        shop_id: this.shop.shop_id,
        begin: "2019-10-01",
        end: "2019-10-31",
        report: true,
        type: "view"
      };
      var queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
      Service.Order.gets(queryString).then(res => {
        this.orderList = res.data;

        this.orderList.sort(
          (a, b) =>
            this.statusOrder.indexOf(a.status) -
            this.statusOrder.indexOf(b.status)
        );

        this.orderList.map(item => {
          if (item.status == "completed") {
            this.amount.revenue += item.amount.total;
            this.amount.delivery += item.amount.delivery;
            this.amount.food += item.amount.food;
            this.amount.extra += item.amount.extra;

            let cog = 0;
            item.order_basket.product_list.map(product => {
              cog += parseInt(product.cog) * product.quantity;
              this.amount.quantity += product.quantity;
            });
            item.amount.cog = cog;
            this.amount.cog += item.amount.cog;
          }
        });
      });
    },
    onCreateInvoice() {
      let params = {
        ...this.invoiceForm,
        shop_id: this.shop.shop_id
      };
    },
    openProduct(item) {
      this.$router.push("/view/product/" + item.product_id);
    },
    onShopDetailSubmit() {
      let data = {
        shop_id: this.shop.shop_id,
        ref_no: this.shop.ref_no,
        shop_name: this.shop.name,
        shop_excerpt: this.shop.excerpt,
        shop_status: this.shop.status,
        shop_latitude: this.shop.latitude,
        shop_longitude: this.shop.longitude,
        shop_formatted_address: this.shop.formatted_address
      };

      this.showLoading();
      Service.Shop.update(data).then(res => {
        this.title = this.shop.name;
        this.editDetail = false;
        this.hideLoading();
      });
    },
    onDeliveryTypeChanged() {
      let data = {
        ref_no: this.shop.ref_no,
        delivery_type: this.selectedDeliveryType
      };
      Service.Shop.update(data).then(res => {});
    },
    onOrderTypeChanged() {
      let data = {
        ref_no: this.shop.ref_no,
        allow_delivery: 0,
        allow_pickup: 0
      };
      if (this.selectedOrderType.includes("delivery")) {
        data.allow_delivery = 1;
      }
      if (this.selectedOrderType.includes("pickup")) {
        data.allow_pickup = 1;
      }
      Service.Shop.update(data).then(res => {});
    },
    onLineGroupSaved() {
      let data = {
        shop_id: this.shop.shop_id,
        ref_no: this.shop.ref_no,
        shop_linegroup_id: this.shop.linegroup_id
      };
      Service.Shop.update(data).then(res => {});
    },
    onClusterSave() {
      //console.log(this.clusterForm.delivery_range[0]);
      if (
        this.clusterForm.delivery_startTime < this.clusterForm.order_endTime
      ) {
        alert("ช่วงเวลาจัดส่งต้องอยู่หลังช่วงเวลารับออเดอร์");
        return;
      }
      let cluster = {
        id: Math.floor(Math.random() * 100 + 999).toString(),
        advanced: this.clusterForm.advanced,
        order_start_time: this.clusterForm.order_startTime,
        order_end_time: this.clusterForm.order_endTime,
        delivery:
          this.clusterForm.delivery_startTime +
          "-" +
          this.clusterForm.delivery_endTime,
        selected: false
      };

      var clusters = this.clusterJson;

      clusters.push(cluster);

      let data = {
        ref_no: this.shop.ref_no,
        cluster_json: clusters
      };
      Service.Shop.update(data).then(res => {});

      this.newClusterDialog = false;
    },
    onRemoveCluster(item) {
      let index = this.clusterJson.findIndex(x => x.id == item.id);
      this.clusterJson.splice(index, 1);
      let data = {
        ref_no: this.shop.ref_no,
        cluster_json: this.clusterJson
      };
      Service.Shop.update(data).then(res => {});
    },
    onCategoryDragEnded() {
      let data = { list: [], ref_no: this.ref_no };
      data.list = this.categoryDraggableList.map((item, index) => {
        return {
          product_cate_id: item.value,
          rank: index + 11
        };
      });
      console.log(data);
      Service.Shop.sortCategories(data).then(res => {
        console.log(res);
      });
    },
    openEditCategoryDialog(item) {
      this.selectedCategory = item;
      this.editCategoryDialog = true;
    },
    onEditCategory() {
      let data = {
        cateId: this.selectedCategory.value,
        name: this.selectedCategory.label
      };
      Service.Product.editCategory(data).then(res => {
        Service.Shop.getCategories(this.shop.shop_id).then(res => {
          if (res.success) {
            this.categoryList = res.data.map(item => {
              return {
                label: item.name,
                value: item.product_cate_id,
                rank: item.rank
              };
            });

            this.categoryList.push({ label: "อื่นๆ", value: 0 });
            this.editCategoryDialog = false;
          }
        });
      });
    },
    onRemoveCategory(item) {
      Service.Product.removeCategory(item.value).then(res => {
        Service.Shop.getCategories(this.shop.shop_id).then(res => {
          if (res.success) {
            this.categoryList = res.data.map(item => {
              return {
                label: item.name,
                value: item.product_cate_id,
                rank: item.rank
              };
            });
            this.categoryList.push({ label: "อื่นๆ", value: 0 });
          }
        });
      });
    },
    isPhoneNo(input) {
      var regExp = /^0[0-9]{8,9}$/i;
      return regExp.test(input);
    },
    validURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      ); // fragment locator
      return !!pattern.test(str);
    },
    onContactAdded() {
      if (this.contact.value != "") {
        if (this.shop.contacts == null) {
          this.shop.contacts = [];
        }

        if (this.contact.type == "mobile") {
          this.contact.value = this.contact.value.replace(/\s/g, "");
          if (!this.isPhoneNo(this.contact.value)) {
            alert("รูปแบบเบอร์มือถือไม่ถูกต้อง");
            return;
          }
        }

        if (this.contact.type == "fbpage") {
          if (!this.validURL(this.contact.value)) {
            alert("รูปแบบ URL ไม่ถูกต้อง");
            return;
          }
        }

        this.shop.contacts.push(this.contact);

        let data = {
          ref_no: this.shop.ref_no,
          shop_contacts: this.shop.contacts
        };

        this.showLoading();
        Service.Shop.update(data).then(res => {
          this.contact = { type: "mobile", value: "" };
          this.hideLoading();
        });
      }
    },
    onContactDeleted(index) {
      this.shop.contacts.splice(index, 1);
      let data = {
        ref_no: this.shop.ref_no,
        shop_contacts: this.shop.contacts
      };
      this.showLoading();
      Service.Shop.update(data).then(res => {
        this.hideLoading();
      });
    },
    onUpdateHour() {
      let data = {
        ref_no: this.shop.ref_no,
        hours: this.deliveryHours.items
      };

      this.showLoading();
      Service.Shop.update(data).then(res => {
        this.hideLoading();
        this.editHour = false;
      });
      //console.log(JSON.stringify(data));
    },
    onUpdateHourCancelled() {
      this.renderHours();
      this.editHour = false;
    },
    onSaveAddress(data) {
      var numeral = require("numeral");
      this.shop.formatted_address = data.address;
      this.shop.latitude = numeral(data.lat).format("0.00000");
      this.shop.longitude = numeral(data.lng).format("0.00000");
      this.addressDialog = false;
    },
    onImageLogoChanged(image, type) {
      //console.log("New picture selected!");
      if (image) {
        let data = {
          image: image,
          shop_id: this.shop.shop_id,
          type: "logo"
        };
        Service.Shop.upload(data);
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },
    onImageCoverChanged(image, type) {
      //console.log("New picture selected!");
      if (image) {
        let data = {
          image: image,
          shop_id: this.shop.shop_id,
          type: "cover"
        };
        Service.Shop.upload(data);
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },
    onUpdateStatus(item) {
      let data = {
        product_id: item.product_id,
        status: item.status
      };
      Service.Product.update(data).then(res => {});
    },
    onUpdateCategory(item) {
      let data = {
        product_id: item.product_id,
        shop_id: item.shop_id,
        product_cate_id: item.groups[0].id
      };
      Service.Product.update(data).then(res => {});
    },
    loadMapDrawingManager() {
      if (this.$refs.gmap) {
        let vm = this;
        const drawingManager = new google.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [
              google.maps.drawing.OverlayType.POLYGON,
              google.maps.drawing.OverlayType.CIRCLE
            ]
          },
          polygonOptions: {
            fillColor: "#0099FF",
            fillOpacity: 0.7,
            strokeColor: "#AA2143",
            strokeWeight: 2,
            editable: true
          }
        });
        drawingManager.setMap(this.$refs.gmap.$mapObject);

        google.maps.event.addListener(
          drawingManager,
          "overlaycomplete",
          function(event) {
            if (event.type == "polygon") {
              // Get overlay paths
              let paths = event.overlay.getPath().getArray();
              // Remove overlay from map
              //event.overlay.setMap(null);

              // Disable drawingManager
              drawingManager.setDrawingMode(null);

              // Create Polygon
              vm.savePolygon(paths);
            } else if (event.type == "circle") {
              //console.log(event.overlay);
              vm.saveCircle(event.overlay);
            }
          }
        );

        let tierColors = [
          "#FF0000",
          "#d5a6bd",
          "#b4a7d6",
          "#9be3ff",
          "#e1c936",
          "#61c5a9"
        ];
        /*
        Service.Shop.getServiceArea(this.shop.shop_id).then(res => {
          if (res.success) {
            res.data.map(item => {
              console.log(item);
              if (item.boundary.type == "Polygon") {
                let points = item.boundary.coordinates[0].map(coord => {
                  return { lat: coord[1], lng: coord[0] };
                });
                this.polygonList.push({
                  id: item.id,
                  paths: points,
                  tier_price: item.tier_price - 1
                });
              }
            });
            // Construct the polygon.
            this.polygonList.map((item, index) => {
              var polygon = new google.maps.Polygon({
                paths: item.paths,
                strokeColor: tierColors[index],
                strokeOpacity: 0.6,
                strokeWeight: 2,
                fillColor: tierColors[index],
                fillOpacity: 0.35
              });
              polygon.setMap(this.$refs.gmap.$mapObject);
            });
          }
        });
        */
      }
    },
    savePolygon(paths) {
      let area_value = [];
      paths.map((item, i) => {
        var lat = item.lat();
        var lng = item.lng();
        area_value.push(lng + " " + lat);
      });
      area_value.push(paths[0].lng() + " " + paths[0].lat());
      console.log(JSON.stringify(area_value));
      let data = {
        shop_id: this.shop.shop_id,
        area_value: area_value,
        area_type: "polygon"
      };
      /*
      Service.Shop.addServiceArea(data).then(res => {
        console.log(res);
      });
      */
    },
    saveCircle(paths) {
      console.log(paths.radius);
      /*
      var lat = paths.center.lat();
      var lng = paths.center.lng();
      var radius = paths.radius;
      */
      let data = {
        shop_id: this.shop.shop_id,
        area_value: {
          lat: paths.center.lat(),
          lng: paths.center.lng(),
          radius: paths.radius
        },
        area_type: "circle"
      };
      Service.Shop.addServiceArea(data).then(res => {
        console.log(res);
      });
    },
    onProductCreated(data) {
      this.productDrawer = false;
      this.loadProduct();
    },
    handleImportProgress() {
      this.showLoading();
    },
    handleImportSuccess() {
      this.productUploadDrawer = false;
      this.hideLoading();
      this.loadProduct();
    },
    renderHours() {
      var groups = this.shop.hours.reduce(function(obj, item) {
        obj[item.type] = obj[item.type] || [];
        obj[item.type].push({
          ...item,
          closed: false
        });
        return obj;
      }, {});

      var myArray = [];

      myArray = Object.keys(groups).map(function(key) {
        return {
          title: key,
          items: groups[key]
        };
      });

      this.deliveryHours = myArray.find(x => x.title == "delivery");
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
    },
    hideLoading() {
      this.loading.close();
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadMapDrawingManager();
    }, 2000);
  }
};
</script>
<style lang="scss">
#fileInput {
  display: none;
}
.img-preview {
  width: 90%;
}

.image-wrapper {
  width: 90%;
  border: 1px solid #aaa;
  &:hover {
    cursor: pointer;
  }
}

.pic {
  width: 50px;
  height: 50px;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  background-size: cover;
}
</style>

